import { Row, Col, Accordion } from "react-bootstrap"
import * as S from "./styled"
import { Modal } from "../../../Modal"
import Link from "../../../Base/link"
import { item as text } from "../../../../i18n/pt.json"
import { mountRedirect } from "../../../../utils/redirect.service"

const Collapse = ({ item, details, enable, deleteVariation }) => (
  <Accordion.Collapse style={{ transition: "all 500ms" }} in={enable} eventKey="0">
    <S.Table>
      <thead>
        <tr>
          <S.Th>Grau</S.Th>
          <S.Th>Diâmetro</S.Th>
          <S.Th>Valor</S.Th>
          <S.Th>Qtd.</S.Th>
          <S.Th>Total</S.Th>
          <S.Th>Excluir</S.Th>
        </tr>
      </thead>
      <tbody>
        {details.map((detail) => (
          <tr key={detail.OPCCOD} data-testid="gradeDetailRow">
            <S.Td left>{detail.MEDIDAS}</S.Td>
            <S.Td>{detail.DIAMETRO}</S.Td>
            <S.Td>{detail.PRECO}</S.Td>
            <S.Td>{detail.QUANTIDADE}</S.Td>
            <S.Td>{detail.VALORTOTAL.toFixed(2)}</S.Td>
            <S.Td>
              <Modal fn={deleteVariation} deleteModal props={detail.OPCCOD} variation />
            </S.Td>
          </tr>
        ))}
      </tbody>
    </S.Table>
  </Accordion.Collapse>
)

export const Header = () => {
  const { header } = text

  return (
    <S.Header className="d-flex w-100">
      <Col xs={3}>
        <S.TextHeader>{header.product}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-none d-lg-block">
        <S.TextHeader>{header.QtdTotal}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-sm-none d-xs-block">
        <S.TextHeader>{header.Qtd}</S.TextHeader>
      </Col>
      <Col xs={3}>
        <S.TextHeader>{header.value}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-none d-lg-block">
        <S.TextHeader>{header.edition}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-sm-none d-xs-block">
        <S.TextHeader>{header.edit}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-none d-lg-block">
        <S.TextHeader>{header.delete}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-sm-none d-xs-block">
        <S.TextHeader>{header.del}</S.TextHeader>
      </Col>
    </S.Header>
  )
}

export const Layout = ({
  item,
  editRoute,
  details,
  handleDelete,
  deleteVariation,
  collapse,
  toggleCollapse,
  isMobile,
}) => (
  <Accordion>
    <S.Description
      onClick={toggleCollapse}
      data-testid="openCollapseGrade"
      isMobile={isMobile}
      darker={item.darker}
    >
      <Row>
        <S.PaddingLen xs={3}>
          <Link action={editRoute}>
            <S.Lente url={item.lente} />
          </Link>
        </S.PaddingLen>
        <Col xs={2}>{item.qty}</Col>
        <Col xs={3}>{item.total}</Col>
        <Col xs={2} onClick={(e) => e.stopPropagation()}>
          <S.IconEdit
            data-testid="editRedirectGrade"
            item={item.itemID}
            onClick={mountRedirect(editRoute)}
          />
        </Col>
        <Col xs={2} onClick={(e) => e.stopPropagation()}>
          <Modal deleteModal fn={handleDelete} />
        </Col>
      </Row>
    </S.Description>

    <Collapse item={item} deleteVariation={deleteVariation} details={details} enable={collapse} />
  </Accordion>
)
